<template>
  <div class="content">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
      <base-header class="header--recipe mb-6" type="none">
        <b-row align-v="center" class="py-4">
          <h1>Recipe Uploader</h1>
        </b-row>
      </base-header>
      <b-container
        class="container--md mt--6"
      ></b-container> 
      <card class="no-border-card card-instructions">
        <vue-dropzone
        ref="myVueDropzone"
        :useCustomSlot="true"
        id="dropzone"
        @vdropzone-upload-progress="uploadProgress"
        :options="dropzoneOptions"
        @vdropzone-file-added="fileAdded"
        @vdropzone-sending-multiple="sendingFiles"
        @vdropzone-success-multiple="success"
        v-on:vdropzone-success="uploadSuccess"
        ></vue-dropzone>
      </card>
  </div>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import swal from 'sweetalert2'
  import { importHeader } from '../../_helpers';
  
  export default {
    title: "uploader",
    props: ['recipeData'],
    components: {
      vueDropzone: vue2Dropzone
    },
    data() {
      return {
        dropzoneOptions: {
          // The Url Where Dropped or Selected files will be sent
          url: `${process.env.VUE_APP_API_HOSTNAME}/api/import/upload`,
          // File Size allowed in MB
          maxFilesize: 902400000,
          // Authentication Headers like Access_Token of your application
          headers: importHeader(),
          // The way you want to receive the files in the server
          paramName: function(n) {
            return "file[]";
          },
          dictDefaultMessage: "Upload Files Here xD",
          includeStyling: false,
          previewsContainer: false,
          thumbnailWidth: 250,
          thumbnailHeight: 140,
          uploadMultiple: true,
          paramName: () => "files",
          parallelUploads: 20
        }
      }
    },
    computed: {
    },
    methods: {
      onCreated() {
      },
      uploadSuccess: function(file, response) {
        swal.fire({
          title: `File has been processed`,
          text: '',
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'Close',
          buttonsStyling: false,
        })
      }
    },
    created(){
      this.onCreated();
    },
    mounted() {
    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>
<style></style>
